import { FC } from 'react';
import { UserPermission } from 'constants/userPermission';
import { useNavigate } from 'react-router-dom';
import UserPermissionGate from 'components/UserPermissionGate';
import { Button, ButtonProps, Icon } from '@kontentino/ui';
import { modalRoutes } from 'constants/routes';
import { faPlus } from '@fortawesome/pro-regular-svg-icons/faPlus';
import { useTranslation } from 'react-i18next';
import { ActionButton } from 'app/components/actions/ActionButton';
import { useActions } from 'app/hooks/useActions';
import { buildAnalyticsManageProfileGroupSearch } from 'app/modules/analytics/utils/buildAnalyticsManageProfileGroupSearch';
import { useAnalyticsSelection } from 'app/modules/analytics/hooks/useAnalyticsSelection';

const SHARED_BUTTON_LAYOUT: Omit<ButtonProps, 'variant'> = {
  size: 'small',
  style: { width: '100%' },
  iconBefore: <Icon icon={faPlus} />,
};

const AnalyticsProfileSelectorFooter: FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { profileActions } = useActions('profile-selector');
  const { markAwaitingCreatedGroup } = useAnalyticsSelection();

  return (
    <div className="tw-border-t tw-border-grayscale-20">
      <UserPermissionGate
        exact={false}
        scopes={[
          UserPermission.PAGE_CREATE,
          UserPermission.PAGE_PRESETS_MANAGE,
        ]}
      >
        <div className="tw-flex tw-gap-2 tw-p-4">
          <UserPermissionGate scopes={UserPermission.PAGE_CREATE}>
            <ActionButton
              {...SHARED_BUTTON_LAYOUT}
              action={profileActions.add}
              data-name="analytics-profile-select-new-social-profile"
              data-cy="analytics_profile-selector_add-profile-button"
              variant="primary"
            >
              {t('profile')}
            </ActionButton>
          </UserPermissionGate>
          <UserPermissionGate scopes={UserPermission.PAGE_PRESETS_MANAGE}>
            <Button
              {...SHARED_BUTTON_LAYOUT}
              variant="tertiary"
              onClick={() => {
                markAwaitingCreatedGroup();
                navigate({
                  hash: modalRoutes.MANAGE_PROFILE_GROUP,
                  search: buildAnalyticsManageProfileGroupSearch(),
                });
              }}
              data-cy="analytics_profile-selector_create-group-button"
              data-name="analytics-profile-select-new-profile-group"
            >
              {t('createGroup')}
            </Button>
          </UserPermissionGate>
        </div>
      </UserPermissionGate>
    </div>
  );
};

export default AnalyticsProfileSelectorFooter;
